import { render } from "./LoadingIcon.vue?vue&type=template&id=7c628192&scoped=true&ts=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=ts"
export * from "./LoadingIcon.vue?vue&type=script&lang=ts"

import "./LoadingIcon.vue?vue&type=style&index=0&id=7c628192&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c628192"]])

export default __exports__